module.exports = __webpack_public_path__ + "static/media/video-case-virtual-showroom.f55e1707.mp4";